import BaseApi from './base-api';

class Authorization extends BaseApi {
  login(username, password) {
    return this.apiFetch('/api/v1/Account/Login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  }

  changePassword(passwords) {
    return this.authorizedFetch('/api/v1/Account/changePassword', {
      method: 'POST',
      body: JSON.stringify(passwords),
      parseAsText: true,
    });
  }

  resetPassword(dto) {
    return this.apiFetch('/api/v1/account/ResetPassword', {
      method: 'POST',
      body: JSON.stringify(dto),
      parseAsText: true,
    });
  }

  activateAccount(dto) {
    return this.apiFetch('/api/v1/account/activationcode', {
      method: 'POST',
      body: JSON.stringify(dto),
    });
  }

  confirmEmail(dto) {
    return this.apiFetch('/api/v1/account/confirmEmail', {
      method: 'POST',
      body: JSON.stringify(dto),
    });
  }

  * refreshAccessToken(refreshToken) {
    return yield this.apiFetch('/api/v1/Account/Login', {
      method: 'POST',
      body: JSON.stringify({
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
      }),
    });
  }
}

export default Authorization;
